export default {
  title: '接收代幣', close: '關閉接收地址視窗', qrTitle: '{{source}} World Chain 接收地址 QR Code', address: '{{source}} 地址',
  chainAddress: 'World Chain 接收地址', copy: '複製地址', copied: '地址已複製。', copyFailed: '無法複製地址，請手動複製。',
  unavailable: '目前沒有可用的 {{source}} 接收地址，請先連接 MetaMask 或登入，以取得 World Chain 錢包地址。',
} as const;

